<template>
  <div v-if="tabs && tabs.length > 0" class="lf-modal__tabs">
    <div
      v-for="(tab, index) in tabs"
      :key="index"
      class="lf-modal__tab"
      :class="{ 'lf-modal__tab--active': activeTab === index }"
      @click.stop="onTabClick(index, tab)"
    >
      <span class="lf-modal__tab-text">{{ tab.label }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, PropType, ref } from 'vue';
import { TabItem } from '@/components/components/editing/Modals/interfaces';

export default defineComponent({
  name: 'ModalTabs',
  props: {
    tabs: {
      type: Array as PropType<TabItem[]>
    }
  },
  emits: ['onSetTab'],
  setup(props, context) {
    const activeTab = ref(0);

    const onTabClick = (tabIndex: number, tab: TabItem) => {
      activeTab.value = tabIndex;
      if (tab.alias) {
        context.emit('onSetTab', tab.alias);
      } else {
        context.emit('onSetTab', tab);
      }
    };

    /**
     * By default, we want to set the first tab to be active, which means we need to emit the alias back to the parent.
     */
    onMounted(() => {
      activeTab.value = 0;
      if (props.tabs) {
        context.emit('onSetTab', props.tabs[0].alias);
      }
    });

    return {
      activeTab,
      onTabClick
    };
  }
});
</script>
